import { useEffect } from 'react';
import { identifyOnboardingTypeByPath } from 'utilities/onboardingTypeHelper';

export const useUpdateOnboardingTypeByPromotionalCode = ({ promotionalCode, formActions }) => {
    useEffect(() => {
        if (!promotionalCode?.get('promotionalCode').get('code')) {
            formActions.change('userProfile.onboardingType', identifyOnboardingTypeByPath(window.location.pathname));
        }
    }, [promotionalCode]);
};
